import { useFirestore } from "@/hooks/firestore/core/useFirestore";
import { bettingEventStatus } from "@/hooks/firestore/models/bettingEventStatus";

const useBettingEventStatuses = (eventId: string) => {
  const { data, isLoading, error } = useFirestore(
    eventId && `/bettingEventStatuses/${eventId}`,
    bettingEventStatus,
  );

  return {
    bettingEventStatus: data,
    isLoading,
    error,
  };
};

type BettingEventStatus = Exclude<
  ReturnType<typeof useBettingEventStatuses>["bettingEventStatus"],
  undefined
>;

export { useBettingEventStatuses, type BettingEventStatus };
